import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormCommunityComponent } from './form-community/form-community.component';
import { HomeComponent } from './home/home.component';
import { AboutTheTitanAppComponent } from './about-the-titan-app/about-the-titan-app.component';
import { LearnToUseTheTitanAppComponent } from './learn-to-use-the-titan-app/learn-to-use-the-titan-app.component';
import { TrustworthyTitansComponent } from './trustworthy-titans/trustworthy-titans.component';
import { TitanInformationComponent } from './titan-information/titan-information.component';
import { EmbeddedFormComponent } from '../embedded-form/embedded-form.component';
const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'about-the-titan-app',
    component: AboutTheTitanAppComponent,
  },
  {
    path: 'learn-to-use-the-titan-app',
    component: LearnToUseTheTitanAppComponent,
  },

  {
    path: 'trustworthy-titans',
    component: TrustworthyTitansComponent,
  },
  {
    path: 'titan-information',
    component: TitanInformationComponent,
  },
  {
    path: 'otra',
    component: FormCommunityComponent,
  },
  {
    path: 'embedded-form',
    component: EmbeddedFormComponent,
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
